import React, {useEffect, useState} from 'react';
import {
    setCategory,
    setFilter,
    setForm,
    setItem,
    setLoading,
    setTableParams,
    setViewMode
} from "../../../redux/actions/generics/IndexedActions";
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {moduleService} from "../../../jwt/_services";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import {Card, CardBody, CardTitle, Collapse} from "reactstrap";
import {GenericButton} from "../../../components/buttons/customButtons";
import {DragDropList} from "../../../components/draggableList/DragDropList";
import ModuleControllerForm from "./_form";
import {LIST} from "../../../components/i18n/i18n";

const ModuleControllerList = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = componentState?.data;

    const [categorizedItems, setCategorizedItems] = useState([]);

    useEffect( () => {
        if( filter)
            return

        props.setFilter(path , {
        });
    }, [  ]);

    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, moduleService, pageIndex, 1000, filter)
    }, [pageIndex, pageSize, filter ]);

    useEffect(() => {
        mapItemsToCategoryItems(listDomainObjects);
    }, [listDomainObjects]);

    const handleTableChange = (_page) => {
        let currentIndex = (_page - 1) * pageSize;
        props.setTableParams(path, pageSize, currentIndex, totalSize, currentIndex );
    };

    const mapItemsToCategoryItems = (_listItems) => {
        const groupedItems = [];

        for (const item of _listItems) {
            const category = groupedItems.find(c => c.name === item.categoryName);

            if (!category) {
                groupedItems.push({
                    id: item.category,
                    name: item.categoryName,
                    isOpen: true,
                    items: [item],
                });
            } else {
                category.items.push(item);
            }
        }
        // sort by categoryName

        groupedItems.sort((a, b) => b.name.localeCompare(a.name));

        groupedItems.map(group => group.items.sort((a, b) => a.showOrder - b.showOrder));

        setCategorizedItems( groupedItems );
    };

    const onExpandContract = (index) => {
        let updatedCategorizedItems = [...categorizedItems];
        updatedCategorizedItems[index].isOpen = !updatedCategorizedItems[index].isOpen;
        setCategorizedItems(updatedCategorizedItems);
    }

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path);
        props.setCategory(path, null);
        ModalFormContainer( ModuleControllerForm, { path } )
    }
    const createItemAtCategory = (category) => {
        props.setItem(path, null);
        props.setForm(path);
        props.setCategory(path, category);
        ModalFormContainer( ModuleControllerForm, { path } )
    }

    const editItem = (data) => {
        props.setForm(path, true, false, false);
        props.setItem(path, data);

        ModalFormContainer(ModuleControllerForm, { path, data, Form: ModuleControllerForm })
    }

    const onReorder = (reorderProps) => {
        // Crear una copia de listDomainObjects para evitar mutaciones directas
        let updatedListDomainObjects = [...listDomainObjects];
        let dataRequest = {
            items: []
        }

        for (const reorderedItem of reorderProps.list) {
            // Validar si el ítem tiene un id (es decir, si existe en la base de datos)
            if (reorderedItem.id) {
                // Buscar el ítem en listDomainObjects
                let domainObject = updatedListDomainObjects.find(domainObject => domainObject.id === reorderedItem.id);

                if (domainObject && domainObject.showOrder !== reorderedItem.showOrder) {
                    dataRequest.items.push({
                        id: domainObject.id,
                        showOrder: reorderedItem.showOrder
                    })
                }

            }
        }

        console.log(dataRequest);
        return;
        //genericIndexedActions.reorder(path, moduleService, dataRequest)
    }

    const setIconView = (value) => {
        let img;
        try {
            img = require("../../../assets/images/icon/modules/" + value);
        } catch (e) {
            img = null;
        }
        return img;
    }

    const renderContent = (item, index) => {
        let iconSource = setIconView(item.icon);

        return (
            <div className={'block_item'} onClick={_ => editItem(item) }>
                <div>
                    <label>{item.name}</label>
                </div>
                <div>
                    <img src={iconSource} alt={item.name}/>
                </div>
            </div>
        )
    }

    const renderEnd = (index) => {
        const categoryGroup = categorizedItems[index];
        return (
            <div className={'draggable-item'}>
                <div className={''}>
                    <GenericButton
                        style={'success-secondary'}
                        label={'Agregar modulo en ' + categoryGroup?.name}
                        toolTip={'Agrega un menu existente'}
                        icon={'fa-plus'}
                        permission={'add'}
                        onClick={_ => createItemAtCategory(categoryGroup)}/>
                </div>
            </div>
        )
    }

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
            <div className="float-right">
                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                />
            </div>
        </CardTitle>
        <CardBody className="">
            {/*<RestaurantControllerFilters path={path}/>*/}
            {
                    categorizedItems.map((categoryGroup, index) => {
                        return (< >
                                <div id={'category-group-header' + index} className={'category-gtoup-header'} >
                                    <h1>{categoryGroup?.name}</h1>
                                    <GenericButton style={'table'}
                                                   toolTip={categoryGroup?.isOpen ? 'Contraer' : 'Expandir'}
                                                   icon={categoryGroup?.isOpen ? 'fa-chevron-up' : 'fa-chevron-down'}
                                                   permission={'search'}
                                                   onClick={_ => onExpandContract(index)} />
                                </div>
                                <div id={'category-group-items' + index} >
                                    <Collapse isOpen={categoryGroup?.isOpen || false}>

                                        {
                                            categoryGroup?.items?.length > 0 &&
                                            <DragDropList
                                                items={categoryGroup?.items}
                                                renderContent={renderContent}
                                                renderEnd={renderEnd}
                                                onReorder={onReorder}
                                                orientationHV={'ruby-text-container'} // CSS class para orientar los elementos horizontalmente
                                                className={''}
                                                groupIndex={index}
                                            />
                                        }
                                    </Collapse>

                                </div>
                            </>
                        )
                    })

            }
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    setLoading,
    setCategory
})
export default connect(mapStateToProps, mapActionsToProps)(ModuleControllerList)